import { AssistQueryClient } from 'services/assist-api/query-client';

/**
 * Clears the queries used to populate the Marking tables, forms, and other views so that these will
 * contain new allocations, status changes, and scores:
 */
export function clearMarkingCache(): void {
  AssistQueryClient.removeQueries(['test-instance-response-markers/marking-tasks']);
  AssistQueryClient.removeQueries(['test-instance-responses/marker-allocation']);
  AssistQueryClient.removeQueries(['test-instance-response-marks']);

  // We also need to refresh the organisation users (used on the Rubric List report and Manage
  // Marking pages to display the marker badge) to ensure that new markers show up straight away:
  AssistQueryClient.removeQueries(['customer-users']);
}
